import axios from 'axios';
import { TokenInvalidoError } from '../errors/TokenInvalidoError';
import { TurnoYaCalificadoError } from '../errors/TurnoYaCalificadoError';
import {
  MENSAJE_TOKEN_INVALIDO,
  MENSAJE_TURNO_INEXISTENTE,
  MENSAJE_TURNO_YA_CALIFICADO,
} from '../constants/calificacionConstants';

const esMensajeTokenInvalido = (mensaje) =>
  mensaje === MENSAJE_TOKEN_INVALIDO || mensaje === MENSAJE_TURNO_INEXISTENTE;

/**
 * Estado actual de la calificación de un turno. Endpoint público, sin JWT.
 * Cualquier error de respuesta del back (token inválido, adulterado, vencido,
 * o que no corresponde a este turno) llega con el mismo mensaje genérico, así
 * que se traduce siempre a TokenInvalidoError.
 */
export const obtenerCalificacionTurno = async (token) => {
  try {
    const { data } = await axios.get(`/v1/turnos/calificacion/${token}`);
    return data;
  } catch (error) {
    if (error?.response) {
      throw new TokenInvalidoError(error.response.data?.error);
    }
    throw error;
  }
};

/**
 * Envía la calificación (1 a 5 estrellas + comentario opcional). Solo debe
 * llamarse si `obtenerCalificacionTurno` dio `yaCalificado: false`.
 */
export const enviarCalificacionTurno = async (token, { valoracion, valoracionObservacion }) => {
  try {
    const { data } = await axios.post(`/v1/turnos/calificacion/${token}`, {
      valoracion,
      valoracionObservacion: valoracionObservacion || null,
    });
    return data;
  } catch (error) {
    if (!error?.response) {
      throw error;
    }

    const mensaje = error.response.data?.error;
    if (mensaje === MENSAJE_TURNO_YA_CALIFICADO) {
      throw new TurnoYaCalificadoError(mensaje);
    }
    if (esMensajeTokenInvalido(mensaje)) {
      throw new TokenInvalidoError(mensaje);
    }
    throw new Error(mensaje || 'No se pudo enviar la calificación. Intentá nuevamente.');
  }
};
